import type { ReactNode } from 'react';
import { create } from 'zustand';

interface HeaderState {
  title: ReactNode | null;
  actions: ReactNode | null;
  bottomComponent: ReactNode | null;
  centerComponent: ReactNode | null;
  backHref: string | null;
  backLabel: string | null;
  setTitle: (title: ReactNode | null) => void;
  setActions: (actions: ReactNode | null) => void;
  setBottomComponent: (bottomComponent: ReactNode | null) => void;
  setCenterComponent: (centerComponent: ReactNode | null) => void;
  setBack: (href: string | null, label?: string | null) => void;
  reset: () => void;
}

export const useHeader = create<HeaderState>((set) => ({
  title: null,
  actions: null,
  bottomComponent: null,
  centerComponent: null,
  backHref: null,
  backLabel: null,
  setTitle: (title) => set({ title }),
  setActions: (actions) => set({ actions }),
  setBottomComponent: (bottomComponent) => set({ bottomComponent }),
  setCenterComponent: (centerComponent) => set({ centerComponent }),
  setBack: (href, label) => set({ backHref: href, backLabel: label ?? null }),
  reset: () =>
    set({
      title: null,
      actions: null,
      bottomComponent: null,
      centerComponent: null,
      backHref: null,
      backLabel: null,
    }),
}));
